import { initSentry } from '@keboola/sentry';

/**
 * Sentry error reporting for the developer portal.
 *
 * - The DSN is a public, write-only key, not a credential.
 * - Whether and under which environment a host reports is `@keboola/sentry`'s shared policy.
 */
initSentry({
  dsn: 'https://0cf3c3511d6b4b02ab8c7456618cc543@sentry.io/201115',
  release: import.meta.env.VITE_RELEASE,
  // eslint-disable-next-line turbo/no-undeclared-env-vars -- Vite built-in, not a real env var
  isDevBuild: import.meta.env.DEV,
  // `--prod` aliases only this until `components.keboola.com` is live (`docs/production-cutover.md`);
  // without it production reads as a preview and reports nothing.
  productionHosts: ['developer-portal-keboola-engineering.vercel.app'],
});
